(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/navbig/assets/javascripts/commands/nav-big-team-command.js') >= 0) return;  svs.modules.push('/components/statistics/navbig/assets/javascripts/commands/nav-big-team-command.js'); 
var svs = svs || {};

(function(svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.big = svs.statistics.big || {};
  svs.statistics.big.commands = svs.statistics.big.commands || {};

  svs.statistics.big.commands.NavBigTeamCommand = function() {
    var assetsLoaded = false;
    var doCreateTeam = function(options) {
      if (
        _.isObject(options.model) &&
        options.model instanceof svs.sport.sport_search.models.SearchTeamList
      ) {
        if (options.teamId) {
          options.model = new svs.statistics.big.models.TeamBigStatisticsModel({
            teamId: options.teamId,
            currentLeagueId: options.currentLeagueId
          });
        }
      } else {
        options.model = null;
      }

      if (
        !_.isObject(options.model) ||
        !(
          options.model instanceof
          svs.statistics.big.models.TeamBigStatisticsModel
        )
      ) {
        options.model = new svs.statistics.big.models.TeamBigStatisticsModel({
          teamId: options.teamId,
          tab: options.tab,
          currentLeagueId: options.currentLeagueId
        });
        options.preDraw = false;

        if (
          options.callType === svs.statistics.big.commands.DEEP_NAVIGATION &&
          options.preDrawType !== svs.statistics.big.commands.PRE_DRAW_TEAM
        ) {
          options.skippAnim = options.skippAnim || false;
        } else {
          options.skippAnim = options.skippAnim || true;
        }
      }
      var bigTeamView = new svs.statistics.big.views.TeamBigStatisticsView(
        options
      );
      return { view: bigTeamView, model: options.model };
    };

    var loadTeam = function(options, cb, cbFunc) {
      options = _.extend(
        {
          teamId: '',
          bigNavRef: this
        },
        options
      );

      options.cb = cb;
      options.cbFunc = cbFunc;

      async.parallel(
        [
          function loadAssets(callback) {
            if (assetsLoaded) {
              callback();
            } else {
              svs.core.module.load(
                '/sportservice/lag/{id}',
                null,
                callback,
                options.teamId
              );
            }
          }
        ],
        onAssetsLoadedAndTeamFetched
      );

      function onAssetsLoadedAndTeamFetched() {
        assetsLoaded = true;
        options.cb[options.cbFunc](options);

        if (options.cbFunc === 'preDrawTeam') {
          options.cb.preDrawTeamLoaded(options);
        }
      }
      return assetsLoaded;
    };

    return {
      doCreateTeam: doCreateTeam,
      loadTeam: loadTeam
    };
  };

  svs.statistics.big.commands.navBigTeamCommand = new svs.statistics.big.commands.NavBigTeamCommand();
})(svs);

 })(window);